
import { defineComponent } from "vue";
import PharmacyMedicationCards from "@/components/PharmacyMedicationCards.vue";
import { mapMutations, mapGetters } from "vuex";
import TransferMedicationDirections from "@/components/TransferMedicationDirectionsComponent.vue";
import { PatientMessagesPayloadViewModel } from "@/interfaces/PatientMessagesPayloadViewModel";
import { rxReceivedScreenView } from "@/interfaces/PharmacyCartViewEnum";
import { PropType } from "vue";
import { PatientAffiliateSubscriptionStatusIDEnum } from "@/interfaces/PatientAffiliateSubscriptionStatusIDEnum";

export default defineComponent({
  name: "pharmacy-portal-view",
  props: {
    marketplaceRxs: {
      type: Array,
      required: true,
    },
    initialTransferRequested: {
      type: Boolean,
      required: true,
    },
    payload: Object as PropType<PatientMessagesPayloadViewModel>,
    familyPlanMembers: {
      type: Array,
      required: false,
      default: () => null,
    },
  },

  data() {
    return {
      noRX: false,
      isChoiceSidebarOpen: false as boolean,
      selectedMedications: [] as Array<object>,
      hasRequestedTransfer: this.initialTransferRequested,
      PatientAffiliateSubscriptionStatusIDEnum,
    };
  },
  computed: {
    ...mapGetters({
      PatientAffiliateSubscription: "getPatientAffiliateSubscription",
    }),
  },

  methods: {
    ...mapMutations({
      setShowPharmacyCart: "setShowPharmacyCart",
      setLoading: "setLoading",
      setMarketplaceRxs: "setMarketplaceRxs",
      setShowMainMenu: "setShowMainMenu",
      setShowSubscriptionManagement: "setShowSubscriptionManagement",
    }),
    updateSelectedMedications({ medication, selected }) {
      this.setShowMainMenu(false); // If user has main menu toggled open and click on a medication they cannot see the fill button
      if (selected) {
        this.selectedMedications.push(medication);
      } else {
        this.selectedMedications = this.selectedMedications.filter((med) => med.drugDisplayName !== medication.drugDisplayName);
      }
    },
    handleFill() {
      this.setMarketplaceRxs(this.selectedMedications);
      this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.cart });
      this.selectedMedications = [];
    },
    openChoices() {
      this.isChoiceSidebarOpen = true;
    },
    hideChoice() {
      this.isChoiceSidebarOpen = false;
    },
    transferToggle() {
      this.hasRequestedTransfer = true;
    },
    handleFailedSubPayment() {
      this.setShowSubscriptionManagement(true);
      this.selectedMedications = [];
    },
  },
  components: {
    PharmacyMedicationCards,
    TransferMedicationDirections,
  },
});
